export default __webpack_public_path__ + "static/media/Colliers_logo.64b1d8db.png";